import * as types from '../mutation-types'

// initial state
const state = {
  accurateMode: localStorage.getItem('accurateMode') ? localStorage.getItem('accurateMode') : 0, // 关键词精确模式(关闭=0,开启=1)
  configAccurateMode: localStorage.getItem('configAccurateMode') ? localStorage.getItem('configAccurateMode') : false // 关键词精确模式开关配置
}

// getters
const getters = {
  accurateMode: state => state.accurateMode,
  configAccurateMode: state => state.configAccurateMode.toString() === "false" ? false : true,
}

// mutations
const mutations = {
  [types.SET_ACCURATE_MODE] (state, accurateMode) {
    state.accurateMode = accurateMode
    localStorage.setItem('accurateMode', accurateMode)
  },
  [types.SET_CONFIG_ACCURATE_MODE] (state, configAccurateMode) {
    state.configAccurateMode = configAccurateMode
    localStorage.setItem('configAccurateMode', configAccurateMode)
  }
}
// actions
const actions = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
